//@flow
import { outletMasterContainerFactory } from 'common/entity/outletMaster/OutletMasterContainer';
import PjpActions from 'common/redux/actions/pjpMaster';
import OutletSelectors from 'common/redux/selectors/outlet';
import nestedEntityDialogFactory from 'common/entity/pjpMaster/NestedEntityDialog';
import PjpSelectors from 'common/redux/selectors/pjpMaster';

const OutletMasterDialog = nestedEntityDialogFactory({
    fetchEntities: PjpActions.fetchPjpOutlets,
    containerFactory: outletMasterContainerFactory,
    getFilteredEntitesCount: OutletSelectors.getFilteredEntitesCount,
    getTotalEntitiesCount: PjpSelectors.getTotalOutletsCount
});

export { OutletMasterDialog };
export default OutletMasterDialog;
